import api from "@/store/api";

const userEnumsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getContactPreferences: build.query<CodedEnumOption[], void>({
      query: () => "/users/enums/contact-preferences",
    }),
    getGenders: build.query<CodedEnumOption[], void>({
      query: () => "/users/enums/genders",
    }),
    getLanguages: build.query<CodedEnumOption[], void>({
      query: () => "/users/enums/languages",
    }),
    getPronouns: build.query<CodedEnumOption[], void>({
      query: () => "/users/enums/pronouns",
    }),
    getRelationsToPatient: build.query<CodedEnumOption[], void>({
      query: () => "/users/enums/relations-to-patient",
    }),
    getUsStates: build.query<UsStateEnumOption[], void>({
      query: () => ({
        url: "/clinical-data/us-states",
      }),
    }),
  }),
});

const {
  useGetContactPreferencesQuery,
  useGetGendersQuery,
  useGetLanguagesQuery,
  useGetPronounsQuery,
  useGetRelationsToPatientQuery,
  useGetUsStatesQuery,
} = userEnumsApi;

export {
  useGetContactPreferencesQuery,
  useGetGendersQuery,
  useGetLanguagesQuery,
  useGetPronounsQuery,
  useGetRelationsToPatientQuery,
  useGetUsStatesQuery,
};
